@if (!template?.settings?.productDetails?.autoAddToCart) {
  @if (effectivePreviewMode === PreviewMode.GiftBanner) {
    <div [ngClass]="!mode ? 'example-wrapper' : 'outer-example-wrapper'">
      <div class="gift-banner" [ngClass]="bannerStyleClasses">
        <img class="gift-banner__image" [src]="template?.giftMessage?.icon" alt="" />
        <div>
          <div class="gift-banner__title">{{ template?.giftMessage?.title }}</div>
          <div class="gift-banner__text">{{ template?.giftMessage?.text }}</div>
        </div>
        <button class="gift-banner__button" [ngClass]="{ 'gift-banner__button__mobile': isMobile }">
          {{ template?.giftMessage?.actionButtonText }}
        </button>
      </div>
    </div>
  } @else if (effectivePreviewMode === PreviewMode.GiftOffer) {
    <div [ngClass]="!mode ? 'example-wrapper' : 'outer-example-wrapper'">
      <div class="offer-preview">
        <div class="offer-preview__header">
          <div class="offer-preview__title">{{ template?.giftPopup?.title || 'Choose your product' }}</div>
          <div class="offer-preview__subtitle">
            {{ template?.giftPopup?.text || 'Select one gift to add to your cart' }}
          </div>
        </div>

        @if (isCompactDisplay) {
          <div class="compact-product">
            <div class="compact-product__image-placeholder"></div>
            <div class="compact-product__details">
              <div class="compact-product__name-row">
                <span class="compact-product__name">Product name</span>
                <div class="compact-product__arrows">
                  <span class="compact-product__arrow">&lsaquo;</span>
                  <span class="compact-product__arrow">&rsaquo;</span>
                </div>
              </div>
              <div class="compact-product__prices">
                @if (template?.settings?.productDetails?.discountConfiguration?.enabled) {
                  <span>${{ discountedPrice }}</span>
                }
                <span
                  [ngClass]="
                    template?.settings?.productDetails?.discountConfiguration?.enabled ? 'price--original' : ''
                  ">
                  $9.99
                </span>
              </div>
            </div>
          </div>
          <button class="offer-preview__primary-button">
            {{ template?.giftPopup?.actionButtonText || 'Claim' }}
          </button>
        } @else {
          <div class="offer-preview__list">
            @for (product of previewProducts; track $index) {
              <div class="list-item">
                <div class="list-item__radio"></div>
                <div class="list-item__image-placeholder"></div>
                <div class="list-item__info">
                  <span class="list-item__name">{{ product.name }}</span>
                  <div class="list-item__prices">
                    @if (template?.settings?.productDetails?.discountConfiguration?.enabled) {
                      <span class="list-item__price--discounted">${{ discountedPrice }}</span>
                    }
                    <span
                      [ngClass]="
                        template?.settings?.productDetails?.discountConfiguration?.enabled
                          ? 'list-item__price--original'
                          : ''
                      ">
                      {{ product.price || '$9.99' }}
                    </span>
                  </div>
                </div>
              </div>
            }
          </div>
          <button class="offer-preview__primary-button">
            {{ template?.giftPopup?.actionButtonText || 'Claim' }}
          </button>
          @if (template?.offer?.declineButtonEnabled) {
            <button class="offer-preview__secondary-button">
              {{ template?.giftPopup?.declineButtonText || 'No thank you' }}
            </button>
          }
        }
      </div>
    </div>
  } @else {
    @if (effectivePreviewMode === PreviewMode.GiftPopup) {
      <div class="popup" [ngClass]="{ popup__mobile: isMobile }">
        <div class="popup__header">
          <img class="popup__close-image" src="/assets/icons/close-circle-icon.png" alt="" />
          <div class="popup__title">{{ template?.giftPopup?.title }}</div>
        </div>
        <div class="popup__text">{{ template?.giftPopup?.text }}</div>

        @if (isCompactDisplay) {
          <div class="compact-product">
            <div class="compact-product__image-placeholder"></div>
            <div class="compact-product__details">
              <div class="compact-product__name-row">
                <span class="compact-product__name">Product name</span>
                <div class="compact-product__arrows">
                  <span class="compact-product__arrow">&lsaquo;</span>
                  <span class="compact-product__arrow">&rsaquo;</span>
                </div>
              </div>
              <div class="compact-product__prices">
                @if (template?.settings?.productDetails?.discountConfiguration?.enabled) {
                  <span>${{ discountedPrice }}</span>
                }
                <span
                  [ngClass]="
                    template?.settings?.productDetails?.discountConfiguration?.enabled ? 'price--original' : ''
                  ">
                  $9.99
                </span>
              </div>
            </div>
          </div>
        } @else {
          <div class="offer-preview__list">
            @for (product of previewProducts; track $index) {
              <div class="list-item">
                <div class="list-item__radio"></div>
                <div class="list-item__image-placeholder"></div>
                <div class="list-item__info">
                  <span class="list-item__name">{{ product.name }}</span>
                  <div class="list-item__prices">
                    @if (template?.settings?.productDetails?.discountConfiguration?.enabled) {
                      <span class="list-item__price--discounted">${{ discountedPrice }}</span>
                    }
                    <span
                      [ngClass]="
                        template?.settings?.productDetails?.discountConfiguration?.enabled
                          ? 'list-item__price--original'
                          : ''
                      ">
                      {{ product.price || '$9.99' }}
                    </span>
                  </div>
                </div>
              </div>
            }
          </div>
        }

        <button class="popup__primary-button">
          {{ template?.giftPopup?.actionButtonText }}
        </button>
        @if (template?.offer?.declineButtonEnabled) {
          <button class="popup__secondary-button">
            {{ template?.giftPopup?.declineButtonText }}
          </button>
        }
      </div>
    } @else {
      <div class="popup">
        <div class="popup__header">
          <img class="popup__close-image" src="/assets/icons/close-circle-icon.png" alt="" />
          <div class="popup__title">{{ template?.missingInformationPopup?.title }}</div>
        </div>
        <div class="popup__text">{{ template?.missingInformationPopup?.text }}</div>
        <button class="popup__primary-button">
          {{ template?.missingInformationPopup?.dismissButtonText }}
        </button>
      </div>
    }
  }
}
